import { GUTTOR_SPACE } from '../../../../../shared/constants/commonConstants';
import React, { ReactElement } from 'react';
import { Col, Row } from 'antd';
import { getDefaultStr } from '../../../../crm/inPatient/service/crmUtils';
import NumberFormatView from '../../../../../shared/components/NumberFormatView/NumberFormatView';
import { RootState } from '../../../../../store';
import { ReconciliationState } from '../../../../../store/models/reconciliationModel';
import { useSelector } from 'react-redux';

const ReconciliationClaimDetailHeader = (): ReactElement => {
  const {reconciliationClaimDetail} = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  const {payerClaimNoFinal, doa, dod, claimedAmount, approvedAmountDischarge, settledAmount,
    utrNumber, utrDate} = reconciliationClaimDetail;

  return <>
    <Col>
      <Row gutter={GUTTOR_SPACE}>
        <div className="reconciliation-claim-details" data-testid="claim-detail-header">
          <Col md={8}>
            <p className="label-title">Claim No.</p>
            <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">{getDefaultStr(payerClaimNoFinal)}</div>
          </Col>
          <Col md={8}>
            <p className="label-title">Date of Admission</p>
            <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">{getDefaultStr(doa, true)}</div>
          </Col>
          <Col md={8}>
            <p className="label-title">Date of Discharge</p>
            <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">{getDefaultStr(dod, true)}</div>
          </Col>
          <Col md={8}>
            <p className="label-title">Claimed Amount</p>
            <div data-testid="claimDetailHeader" className="label-value fsize_sm">
              <NumberFormatView amount={claimedAmount} prefix={'₹ '} fixedDecimalScale={true} />
            </div>
          </Col>
          <Col md={8}>
            <p className="label-title">Approved Amount</p>
            <div data-testid="claimDetailHeader" className="label-value fsize_sm">
              <NumberFormatView amount={approvedAmountDischarge} prefix={'₹ '} fixedDecimalScale={true} />
            </div>
          </Col>
          <Col md={8}>
            <p className="label-title">Settled Amount</p>
            <div data-testid="claimDetailHeader" className="label-value fsize_sm">
              <NumberFormatView amount={settledAmount} prefix={'₹ '} fixedDecimalScale={true} />
            </div>
          </Col>
          <Col md={8}>
            <p className="label-title">UTR No</p>
         <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">{getDefaultStr(utrNumber)}</div>
          </Col>
          <Col md={8}>
            <p className="label-title">UTR Settled Date</p>
            <div data-testid="claimDetailHeader" className="label-value m-b-10 fsize_sm">{getDefaultStr(utrDate, true)}</div>
          </Col></div>
      </Row>
    </Col>
  </>;
};

export default ReconciliationClaimDetailHeader;
